export default function gpuInfo() {
  try {
    const canvas = document.createElement("canvas");
    const webgl = canvas.getContext("webgl2") || canvas.getContext("webgl");

    if (!webgl) {
      return "WebGL not supported";
    }

    const debugInfo = webgl.getExtension("WEBGL_debug_renderer_info");
    return debugInfo && webgl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  } catch (e) {
    return null;
  }
}
